<template>
  <LobbyCard :header="$t('identify-to-access-document')" class="identify-recipient-content">
    <Consent
      v-if="verifyLinkResponse.requireGdprConsent"
      :consent-step="consentStep"
      :submitting-response="false"
      :value="consentGiven"
      @change="setConsent"
    />
    <FriedParagraph>
      {{
        $t('sender-wants-to-identify-yourself_v2', {
          documentName: verifyLinkResponse.documentName,
        })
      }}
    </FriedParagraph>
    <FriedInput
      v-model.trim="recipient.email"
      class="enter-email-input"
      :label="$t('email')"
      data-external="universal-link-gate-email-input"
      :error-message="helpMessage"
      required
      @keydown.enter="!submitDisabled && submit()"
    />
    <template #footer>
      <div class="identify-recipient-modal-footer">
        <FriedParagraph class="redirect-url-error">
          {{ errorMessage }}
        </FriedParagraph>
        <FriedButton
          :loading="loadingRedirectURL"
          :disabled="submitDisabled"
          data-external="universal-link-gate-view-document-button"
          @click="submit"
        >
          {{ $t('access-document') }}
        </FriedButton>
      </div>
    </template>
  </LobbyCard>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import LobbyCard from '@getaccept/lib-shared-new/src/lobby/components/LobbyCard.vue';
import Consent from '@getaccept/lib-shared-new/src/lobby/components/Consent.vue';
import type { VerifyLinkResponse } from '@getaccept/lib-shared-new/src/universal-link/types/verify-link-response';
import { useIdentifyRecipient } from './composables/identify-recipient.composable';

export default defineComponent({
  name: 'IdentifyRecipientModal',
  components: {
    Consent,
    LobbyCard,
  },
  props: {
    verifyLinkResponse: {
      type: Object as PropType<VerifyLinkResponse>,
      required: true,
    },
  },

  setup(props) {
    const {
      loadingRedirectURL,
      submitDisabled,
      submit,
      helpMessage,
      emailInvalid,
      errorMessage,
      recipient,
      consentGiven,
      setConsent,
      consentStep,
    } = useIdentifyRecipient(props.verifyLinkResponse);

    return {
      loadingRedirectURL,
      submitDisabled,
      submit,
      helpMessage,
      emailInvalid,
      errorMessage,
      recipient,
      consentGiven,
      setConsent,
      consentStep,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/lib-shared-new/src/assets/scss/identify-recipient';
</style>
